/**
 * The folders an export can be delivered to, one level at a time: the
 * publishers at the root, a publisher's games one level down.
 *
 * Asked while the Send dialog is open rather than kept anywhere: the folders
 * are maintained on the Dropbox side and the only list worth showing is the
 * one that is there now. An empty answer is normal — this company may not
 * deliver to Dropbox at all — and the dialog's fields still take a typed name
 * when Dropbox cannot be reached.
 */

import { getServerUri } from "./uriUtility";

export async function listDropboxFolders(path = "") {
  try {
    const response = await fetch(getServerUri("version/dropboxFolders"), {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        ...(path ? { path } : {}),
      }),
    });
    if (!response.ok) return { folders: [], reachable: false };
    const data = await response.json();
    return { folders: data.folders || [], reachable: !data.error };
  } catch (err) {
    console.warn("[dropboxApi] could not list folders:", err.message);
    return { folders: [], reachable: false };
  }
}

/**
 * The publisher's folder that holds this game, found from the version folders
 * inside it rather than from its name.
 *
 * Asked only when the names do not match on their own — it costs a Dropbox
 * listing per candidate folder — and answers `null` when nothing is a clear
 * enough match to fill in on someone's behalf.
 */
export async function findDropboxGameFolder(company, code) {
  try {
    const response = await fetch(getServerUri("version/dropboxGameFolder"), {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        company,
        code,
      }),
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data.folder || null;
  } catch (err) {
    console.warn("[dropboxApi] could not identify the game folder:", err.message);
    return null;
  }
}
